import { t } from 'i18next';

import { toastActions } from '@/entities/toast';
import { userActions } from '@/entities/user';
import { userServiceApi } from '@/shared/api/user-service.api';

import { ChangeThemeVariables } from '../model/types/change-theme-api.interface';

const changeThemeApi = userServiceApi.injectEndpoints({
	endpoints: (build) => ({
		changeTheme: build.mutation<string, ChangeThemeVariables>({
			query: (body) => {
				return {
					method: 'PATCH',
					url: 'user/change-theme',
					responseHandler: 'text',
					body,
				};
			},
			async onQueryStarted({ theme }, { queryFulfilled, dispatch }) {
				try {
					await queryFulfilled;
					dispatch(userActions.changeTheme(theme));
					dispatch(
						toastActions.addToast({
							type: 'success',
							message: t('toast.success.theme.change.message'),
							title: t('toast.success.title'),
						}),
					);
				} catch {}
			},
		}),
	}),
});

export const { useChangeThemeMutation } = changeThemeApi;
